<div class="col-10 d-flex justify-content-between parent-container">
    <div class="form-group flex-grow-1 mr-3">
    <label for="status" class="add-crm-label">{{ "CRM.CRM_NOTE_SNAPSHOT.INVESTMENT_STAGE" | translate }}<span class="red">*</span></label>
    <ng-select class="status-dropdown" [(ngModel)]="crmItem.status" [clearable]="false" name="status" id="status" #statusRef="ngModel" (change)="clearSilence()" required [items]="statusDropdownOptions" groupBy="group" bindValue="name" bindLabel="name">
      <ng-template ng-label-tmp let-status="item">
        {{statusLabels[status.name]}}
      </ng-template>
      <ng-template ng-option-tmp let-status="item" let-index="index">
        {{statusLabels[status.name]}} <i *ngIf="crmStatusService.isOptionalStatus(status)" class="optional-status">{{ "CRM.OPTIONAL" | translate }}</i>
      </ng-template>
    </ng-select>
  </div>

  <div class="form-group flex-grow-1 mx-3" *ngIf="crmItem.companies && crmItem.companies.length > 0">
    <label for="storm">{{ "CRM.STORM" | translate }}<span class="red">*</span></label>
    <select (ngModelChange)="crmItem.companies[0].storm = $event"
            [ngModel]="crmItem.companies[0]?.company?.isPrivate ? crmItem.companies[0]?.storm : storm.PUBLIC"
            [disabled]="!crmItem.companies[0]?.company?.isPrivate"
            id="storm" name="storm" class="form-control">
      <option [value]="storm.EARLY_STAGE">{{ "CRM.STORM_TYPES.EARLY_STAGE" | translate }}</option>
      <option [value]="storm.CROSSOVER_IPO">{{ "CRM.STORM_TYPES.CROSSOVER" | translate }}</option>
      <option [value]="storm.PUBLIC" *ngIf="!crmItem.companies[0]?.company?.isPrivate">{{ "CRM.STORM_TYPES.PUBLIC" | translate }}</option>
    </select>
  </div>

  <div class="form-group flex-grow-1 mx-3"  *ngIf="crmItem.companies && crmItem.companies.length > 0">
    <label for="courtship">{{ "CRM.COURTSHIP" | translate }}</label>
    <select [(ngModel)]="crmItem.companies[0].company.courtshipType" id="courtship" name="courtship" class="form-control">
      <option [value]="courtship.NONE" selected>{{ "CRM.COURTSHIP_TYPES.NO_COURTSHIP" | translate }}</option>
      <option [value]="courtship.STANDARD">{{ "CRM.COURTSHIP_TYPES.STANDARD_COURTSHIP" | translate }}</option>
    </select>
  </div>

  <div class="form-group flex-grow-1 mx-3" *ngIf="crmItem.companies && crmItem.companies.length > 0 && crmItem.companies[0]?.company && crmItem.status === crmStatus.RECOMMEND_AWAITING_KEY_INFLECTION">
    <label for="etaki">{{ "CRM.ETAKI" | translate | uppercase }}
      <div *ngIf="crmStatusService.hasEtakiStatus(crmItem)" class="d-inline">
        <sup class="red">*</sup>
      </div>
    </label>
    <input id="etaki" name="etaki" type="text" class="form-control" placeholder="e.g. XQXX"
           [(ngModel)]="crmItem.companies[0].etaki" #etakiRef (blur)="updateSilenceUntil(etakiRef.value)">
  </div>

  <div class="form-group flex-grow-1 ml-3">
    <div *ngIf="showSilenceUntil()">
      <label for="silenceUntilDate">{{ "CRM.ADD_CRM_MODAL.SILENCE_UNTIL" | translate | uppercase }}...
        <div *ngIf="crmStatusService.hasEtakiStatus(crmItem)" class="d-inline">
          <sup class="red">*</sup>
        </div>
      </label>
      <div class="input-group">
        <rms-date-picker id="silenceUntilDate"
                         name="silenceUntilDate"
                         #silenceUntilDateRef="ngModel"
                         [(ngModel)]="silenceUntilDate"
                         (ngModelChange)="silenceUntilChanged.next($event)"
                         [height]="33"
                         [min]="curDate"
                         [isRange]="false"
                         required>
        </rms-date-picker>
      </div>
    </div>
  </div>
</div>
